import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Constants } from "app/helpers/Constants";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NewEventService {
  constructor(
    private helper: HelperService,
    private postService: PostService,
    private httpClient: HttpClient
  ) {}

  getConsCircleListForAddEvent = (parameters: any): Observable<any> => {
    const formData = new FormData();

    formData.append("API_getConsCircleListForAddEvent", "1");
    if (parameters.event_level == "constituency")
      formData.append("const_id", parameters.const_id);

    return this.postService.post(this.helper.getAPIUrl(), formData);
  };

  getSectionList = (cons_circle_id: string): Observable<any> => {
    const formData = new FormData();

    formData.append("getSectionsByConsCircle", "1");
    formData.append("cons_circle_id", cons_circle_id);

    return this.postService.post(this.helper.getAPIUrl(), formData);
  };

  getPanchayats = (cons_circle_id: string): Observable<any> => {
    return this.httpClient.get(environment.ARCHITECT_SEARCH_PLACES, {
      headers: this.postService.getHeaders(),
      params: {
        place_id: cons_circle_id,
        group_id: Constants.UNION_POST.toString(),
      },
    });
  };
  getBranchesByTownPanchayat = (cons_circle_id: string): Observable<any> => {
    return this.httpClient.get(environment.ARCHITECT_SEARCH_PLACES, {
      headers: this.postService.getHeaders(),
      params: {
        place_id: cons_circle_id,
        group_id: Constants.TOWN_PANCHAYAT_POST.toString(),
      },
    });
  };
  getBranchesBySection = (cons_circle_id: string): Observable<any> => {
    return this.httpClient.get(environment.ARCHITECT_SEARCH_PLACES, {
      headers: this.postService.getHeaders(),
      params: {
        place_id: cons_circle_id,
        group_id: Constants.SECTION.toString(),
      },
    });
  };
  getWards = (panchayat_id: string[]): Observable<any> => {
    const formData = new FormData();

    formData.append(this.helper.getMangledName("API_getWardsByPanchayat"), "1");
    formData.append(
      "panchayat_id",
      JSON.stringify(panchayat_id).substring(
        1,
        JSON.stringify(panchayat_id).length
      )
    );

    return this.postService.post(environment.API_WARDS, formData);
  };

  getWardsByConsCircle = (cons_circle_id: string): Observable<any> => {
    return this.httpClient.get(environment.WARD_LIST, {
      headers: this.postService.getHeaders(),
      params: {
        cons_circle_id: cons_circle_id,
      },
    });
  };

  getBranchByPanchayat = (panchayat_id: string): Observable<any> => {
    const formData = new FormData();

    formData.append(this.helper.getMangledName("getBranchByPanchayat"), "1");
    formData.append("panchayat_id", panchayat_id);

    return this.postService.post(environment.API_BRANCH, formData);
  };

  getBranchByWard = (ward_id: string): Observable<any> => {
    const formData = new FormData();

    formData.append(this.helper.getMangledName("getBranchByWard"), "1");
    formData.append("ward_id", ward_id);

    return this.postService.post(environment.API_BRANCH, formData);
  };

  getWardBySection = (section_id: string): Observable<any> => {
    return this.httpClient.get(environment.GET_WARD_BY_SECTION, {
      headers: this.postService.getHeaders(),
      params: {
        section_id: section_id,
      },
    });
  };

  getEventTypes = (parameters: any): Observable<any> => {
    const formData = new FormData();
    var data = this.helper.getPlaceIdAndGroupId(parameters);

    formData.append(this.helper.getMangledName("API_getEventTypes"), "1");
    // formData.append("group_id",parameters.group_id);
    // formData.append(this.helper.getMangledName("barrack_id"), "1");
    // let observable = this.postService.get(environment.API_EVENT_TYPES, formData);

    // let params = "";
    // params = "barrack_id=" + "1";
    // params = params + "&group_id=" + data.group_id;
    // return this.postService.get(environment.API_EVENT_TYPES + "?" + params);
    // let observable = this.postService.get(environment.API_EVENT_TYPES + "?" + params);

    let observable = this.postService.post(this.helper.getAPIUrl(), formData);
    return observable;

    // return this.postService.get(
    //   environment.API_EVENT_TYPES+
    //     "?barrack_id=" +
    //     "1"+
    //     "&group_id=" +
    //     data.group_id
    // );
  };

  getEvent(parameters: any): Observable<any> {
    // console.log(parameters)
    // const formData = new FormData();

    // formData.append(this.helper.getMangledName("getEventById"), "1");
    // formData.append("event_id", parameters.event_id);

    return this.postService.get(
      environment.API_GET_EVENT +
        "?party_post_id=" +
        parameters.party_post_id +
        "&event_id=" +
        parameters.event_id
    );
  }

  addEvent = (formData: FormData): Observable<any> => {
    return this.postService.post(environment.API_ADD_EVENT, formData);
  };

  addBooth = (formData: FormData): Observable<any> => {
    return this.postService.post(environment.API_EVENT, formData);
  };

  getBooths = (parameters: any): Observable<any> => {
    const formData = new FormData();

    formData.append(this.helper.getMangledName("getBoothsByConstituency"), "1");
    formData.append("const_id", parameters.const_id);

    return this.postService.post(environment.API_BOOTHS, formData);
  };

  getPorupalargal = (
    parameters: any,
    union_type: number,
    cons_circle_id: number,
    section_id: number
  ): Observable<any> => {
    var party_post_groups = [5];

    var other_place_ids = -1;
    if (
      union_type == Constants.CORPORATION ||
      union_type == Constants.MUNICIPAL
    ) {
      if (union_type == Constants.CORPORATION) {
        party_post_groups.push(Constants.CORPORATION_POST);
      } else if (union_type == Constants.MUNICIPAL) {
        party_post_groups.push(Constants.MUNICIPAL_POST);
      }
      other_place_ids = section_id;
    } else if (union_type == Constants.TOWN_PANCHAYAT) {
      party_post_groups.push(Constants.TOWN_PANCHAYAT_POST);
    } else if (union_type == Constants.UNION) {
      party_post_groups.push(Constants.UNION_POST);
    }

    const formData = new FormData();

    formData.append(this.helper.getMangledName("getPorupalargal"), "1");
    formData.append("cons_id", parameters.const_id);
    formData.append("cons_circle_id", cons_circle_id.toString());
    formData.append("other_place_ids", other_place_ids.toString());
    formData.append("party_post_groups", party_post_groups.toString());

    return this.postService.post(this.helper.getAPIUrl(), formData);
  };

  addOrganizers = (request: any): Observable<any> => {
    return this.postService.post(
      environment.API_EVENT_ASSOCIATE_ADD,
      this.helper.getURLSearchParamsFromObject(request)
    );
  };
  removeOrganiser = (request: any): Observable<any> => {
    let params = "";
    params = "party_post_id=" + request.party_post_id;
    params = params + "&id=" + request.id;
    return this.postService.delete(
      environment.API_EVENT_ASSOCIATE_REMOVE + "?" + params,
      this.helper.getURLSearchParamsFromObject(request)
    );
  };
  updateDetails = (request: any): Observable<any> => {
    return this.postService.post(
      environment.API_EVENT_UPDATE_DETAILS,
      this.helper.getURLSearchParamsFromObject(request)
    );
  };
  RemoveMedia = (request: any): Observable<any> => {
    console.log(request);
    let params = "";
    params = "party_post_id=" + request.party_post_id;
    params = params + "&event_id=" + request.event_id;
    params = params + "&file_name=" + request.file_name;
    console;
    return this.postService.delete(
      environment.API_EVENT_ATTACHEMENT + "?" + params,
      this.helper.getURLSearchParamsFromObject(request)
    );
  };
  updateEvent = (request: any): Observable<any> => {
    return this.postService.patch(
      environment.API_EVENT,
      this.helper.getURLSearchParamsFromObject(request)
    );
  };

  uploadFile = (request: any): Observable<any> => {
    return this.postService.post(
      environment.API_EVENT_ATTACHEMENT,
      this.helper.getURLSearchParamsFromObject(request)
    );
  };
}
